import React from 'react';

import { Hidden } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import useIsCompany from '../../../../myHooks/useIsCompany';
import CmtVerticalLayout from '../layoutComponents';
import CmtSidebar from '../layoutComponents/Sidebar';
import CmtContent from '../layoutComponents/Content';
import CmtHeader from '../layoutComponents/Header';
import SidebarHeader from '../layoutComponents/SidebarHeader';
import SidebarContent from '../layoutComponents/sidebarContent';
import SidebarToggleHandler from '../layoutComponents/SidebarToggleHandler';

import { HEADER_TYPE, SIDEBAR_TYPE } from '../../../theme/ThemeOptions';
import defaultContext from '../../../contexts/AppContext/defaultContext';
import ContentLoader from '../../../../myComponents/loaders/contentLoader';
import UserDropdown from '../../../../myComponents/userDropdown';
import ClientsBubble from '../../../../myComponents/ClientsBubble';

const useStyles = makeStyles(theme => ({
  header: {
    position: 'static !important',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '& .Cmt-toggle-menu': {
      color: theme.palette.text.primary,
      marginLeft: 15,
    },
  },
  displayFlex: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

const layoutOptionsVertical = {
  headerType: defaultContext.headerType,
  footerType: 'fixed',
  sidebarType: defaultContext.sidebarType,
  isSidebarFixed: defaultContext.isSidebarFixed,
  isSidebarOpen: false,
  showTourOpt: true,
  showFooterOpt: true,
  miniSidebarWidth: 80,
  layoutStyle: defaultContext.layoutType - 80,
  drawerBreakPoint: defaultContext.drawerBreakPoint,
  sidebarWidth: defaultContext.sidebarWidth,
};

const layoutOptionsMinimal = {
  headerType: HEADER_TYPE.STATIC,
  sidebarType: SIDEBAR_TYPE.MINI,
  isSidebarFixed: defaultContext.isSidebarFixed,
  isSidebarOpen: false,
  miniSidebarWidth: 80,
  layoutStyle: defaultContext.layoutType,
};

const CombinedLayout = ({ children, isScreenWide }) => {
  const classes = useStyles();
  const isCompany = useIsCompany();
  return (
    <CmtVerticalLayout
      layoutOptions={isScreenWide ? layoutOptionsVertical : layoutOptionsMinimal}
      header={
        isScreenWide ? (
          false
        ) : (
          <CmtHeader className={classes.header}>
            <Hidden lgUp>
              <div className={classes.displayFlex}>
                <SidebarToggleHandler edge="start" color="inherit" aria-label="menu" />
                {isCompany && <ClientsBubble />}
                <UserDropdown />
              </div>
            </Hidden>
          </CmtHeader>
        )
      }
      sidebar={
        <CmtSidebar>
          <SidebarHeader />
          <SidebarContent />
        </CmtSidebar>
      }>
      <CmtContent>
        {children}
        <ContentLoader />
      </CmtContent>
    </CmtVerticalLayout>
  );
};

export default CombinedLayout;
